import React from 'react'
import { Typography, withStyles } from '@material-ui/core'
import { Icon } from '@iconify/react'
import { CoreIconButton } from 'src/components/core'
import styles from './styles'
import clsx from 'clsx'

const MessageBoxHeader = props => {
  const { icon, title, onClose, classes, isDraggable, hideCloseButton } = props
  return (
    <div className={classes.header}>
      <div className={classes.headerContent}>
        {icon && <img src={icon} alt="warning!" />}
        <Typography
          className={
            isDraggable ? classes.titleStyleDraggable : classes.titleStyle
          }
          dangerouslySetInnerHTML={{ __html: title.toString() }}
        ></Typography>
      </div>
      {!hideCloseButton && (
        <CoreIconButton
          onClick={onClose}
          variant="text"
          color="secondary"
          size="small"
          className={clsx({
            [classes.closeButtonDraggable]: isDraggable === true,
            [classes.closeButton]: isDraggable !== true,
          })}
        >
          <Icon icon="ic:round-close" />
        </CoreIconButton>
      )}
    </div>
  )
}

export default withStyles(styles)(MessageBoxHeader)
